import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'countinue',
    components: {
    },
})

export default class Countinue extends Vue {

    private onBackTolist(key: any) {
        this.$emit('onSwitchComponent', key);
    }

}
